// Special Offers and Daily Deals for Sunsari Restaurant

export const specialOffers = {
  active: true,
  banner: {
    title: "🎉 Special Offers",
    subtitle: "Limited time deals!"
  },
  deals: [
    {
      id: "weekend-special",
      title: "Weekend Family Deal",
      description: "Order 4+ main courses and get FREE desserts for the whole family!",
      discount: "Free Desserts",
      validDays: [6, 0], // Saturday, Sunday
      active: true,
      badge: "Weekend Only"
    },
    {
      id: "first-order",
      title: "First Online Order",
      description: "Get 10% OFF your first online order. Use code: WELCOME10",
      discount: "10% OFF",
      code: "WELCOME10",
      active: true,
      badge: "New Customer"
    },
    {
      id: "student-discount",
      title: "Student Special",
      description: "Show your student ID and get 10% off on À la Carte orders",
      discount: "10% OFF",
      active: true,
      badge: "Students"
    }
  ]
};

// Function to get active offers for today
export const getTodayOffers = () => {
  const today = new Date().getDay(); // 0 = Sunday, 1 = Monday, etc.
  
  return specialOffers.deals.filter(deal => {
    if (!deal.active) return false;
    if (!deal.validDays) return true; // Always valid if no specific days
    return deal.validDays.includes(today);
  });
};

// Loyalty program benefits
export const loyaltyBenefits = {
  tiers: [
    {
      name: "Bronze",
      minPoints: 0,
      benefits: ["1€ = 1 point", "Birthday bonus: 50 points"],
      color: "#CD7F32"
    },
    {
      name: "Silver", 
      minPoints: 500,
      benefits: ["1€ = 1.2 points", "Free appetizer on birthday", "Priority reservations"],
      color: "#C0C0C0"
    },
    {
      name: "Gold",
      minPoints: 1000,
      benefits: ["1€ = 1.5 points", "Free main course on birthday", "VIP events", "10% off all orders"],
      color: "#FFD700"
    }
  ],
  redemption: {
    minimumPoints: 100,
    value: "100 points = 5€ discount"
  }
};
